(function() { module.exports = this["wp"]["apiFetch"]; }());